import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "log-out-app",
  template: "Logging out...",
})
export class LogOutAppComponent {
  elem: any;

  constructor(private route: ActivatedRoute) {}

  async ngOnInit() {
    this.elem = document.documentElement;
  }

  async ionViewWillEnter() {
    window.location.href = `crihub://callback`;
  }
}
